import {Circle, Line, Text} from "react-konva";
import type {GridPoint} from "@/dungeons/model/DungeonGeometry.ts";

export default function GridCalibrationOverlay({calibrationPoints, registeredOrigin, originPoint, hoverOrigin, zoom}: {
    calibrationPoints: GridPoint[];
    registeredOrigin?: GridPoint;
    originPoint?: GridPoint;
    hoverOrigin?: GridPoint;
    zoom: number;
}) {
    return <>
        {calibrationPoints.length === 2 && <Line
            points={calibrationPoints.flatMap(point => [point.x, point.y])}
            stroke="#f59e0b" strokeWidth={2 / zoom} dash={[8 / zoom, 6 / zoom]}/>
        }
        {calibrationPoints.map((point, index) => <Circle key={index} x={point.x} y={point.y}
            radius={6 / zoom} fill="#f59e0b" stroke="white" strokeWidth={2 / zoom}/>) }
        {registeredOrigin && <OriginMarker point={registeredOrigin} zoom={zoom} color="#22d3ee"
                                           label="(0, 0)" opacity={originPoint ? 0.45 : 1}/>}
        {originPoint && <OriginMarker point={originPoint} zoom={zoom} color="#a3e635" label="Neuer Ursprung"/>}
        {hoverOrigin && <Circle x={hoverOrigin.x} y={hoverOrigin.y} radius={10 / zoom}
            stroke="#a3e635" strokeWidth={2 / zoom} dash={[4 / zoom, 3 / zoom]}
            opacity={0.8} listening={false}/>}
    </>;
}

function OriginMarker({point, zoom, color, label, opacity = 1}: {
    point: GridPoint;
    zoom: number;
    color: string;
    label: string;
    opacity?: number;
}) {
    return <>
        <Circle x={point.x} y={point.y} radius={10 / zoom} stroke={color}
                strokeWidth={2 / zoom} opacity={opacity}/>
        <Line points={[point.x - 14 / zoom, point.y, point.x + 14 / zoom, point.y]}
              stroke={color} strokeWidth={2 / zoom} opacity={opacity}/>
        <Line points={[point.x, point.y - 14 / zoom, point.x, point.y + 14 / zoom]}
              stroke={color} strokeWidth={2 / zoom} opacity={opacity}/>
        <Text x={point.x + 12 / zoom} y={point.y - 22 / zoom} text={label}
              fontSize={12 / zoom} fill={color} opacity={opacity}/>
    </>;
}
